import { NavLink } from "react-router-dom";
import styled from "styled-components";

const NavLinkUndecorated = styled(NavLink)`
  text-decoration: none;
`;

export default NavLinkUndecorated;
